export default "/assets/images/filter-recommandation-BB.3d93c24fa9cfa174.webp";